// @flow
import JQueryView, { on } from '../../../common/JQueryView';

declare var $: any;

export default class IssueView extends JQueryView {
  constructor() {
    super('.company.matching.settings.issues');
    this.renderIssueArea();
  }

  @on({ event: 'click', selector: '.remove_fields' })
  onClickRemoveFields(event: any) {
    $(event.target)
      .prev('input[type=hidden]')
      .val('1');
    $(event.target)
      .closest('fieldset')
      .hide();
    event.preventDefault();

    this.renderIssueArea();
  }

  @on({ event: 'click', selector: '.add_fields' })
  onClickAddFields(event: any) {
    const time = new Date().getTime();
    const regexp = new RegExp($(event.target).data('id'), 'g');
    event.preventDefault();
    $(event.target).before(
      $(event.target)
        .data('fields')
        .replace(regexp, time),
    );

    this.renderIssueArea();
  }

  renderIssueArea() {
    const maxProblemCount = 5;
    if ($('.label-problem:visible').length >= maxProblemCount) {
      $('.add-problem').hide();
    } else {
      $('.add-problem').show();
    }

    let problemNumber = 1;
    $('.problems-wrapper')
      .find('.problem-field')
      .each((index, item) => {
        if ($(item).is(':visible')) {
          const titleField = $(item).find('.title-field');
          const detailField = $(item).find('.detail-field');
          const problemField = $(item).find('.label-problem');
          const removeField = $(item).find('.remove_fields');
          if (problemNumber == 1) {
            removeField.hide();
          } else if (problemNumber != 1) {
            problemField.addClass('not-first-problem');
          }
          problemField.text(`課題${problemNumber}`);
          removeField.attr('id', `remove_field_${problemNumber}`);
          titleField.addClass(`title_field_${problemNumber}`);
          detailField.addClass(`detail_field_${problemNumber}`);
          problemNumber += 1;
        }
      });
  }
}
